import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'ささえiでんわ',

  // model
  videoChatModel: [],
  serviceModel: [],
  deviceModel: [],
  attributeModel: [],

  // model : サービス運用者の場合のみ
  serviceInfoModel: {},
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {videoChatParams, serviceParams}) {
    return new Promise((resolve, reject) => {
      const isAdmin = this.getters['auth/isAdmin']
      const userServiceUuid = this.getters['auth/userServiceUuid']

      const types = []
      const methods = []
      const parameters = []

      // システム管理者の場合
      if (isAdmin) {
        // サービス一覧を取得
        types.push('service')
        methods.push('v1ServiceListGet')
        parameters.push({})

      // サービス運用者の場合
      } else {
        // ささえiでんわ一覧を取得
        types.push('videoChat')
        methods.push('v1VideoChatListGet')
        parameters.push(videoChatParams)
        // ユーザーが属するサービス情報を取得
        types.push('service')
        methods.push('v1ServiceDetailGet')
        parameters.push(serviceParams)
      }

      ApiManager.request(types, methods, parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            // commit('setVideoChatModel', res[0].data.phonebookLocations)
            // console.log('videoChatModel', state.videoChatModel)

            if (isAdmin) {
              commit('setServiceModel', res[0].data.serviceInfo)
              console.log('serviceModel', state.serviceModel)

            } else {
              commit('setVideoChatModel', res[0].data.phonebookLocations)
              console.log('videoChatModel', state.videoChatModel)
              commit('setServiceInfoModel', res[1].data.serviceBasicInfo)
              console.log('serviceInfoModel', state.serviceInfoModel)
            }
            // commit('setDeviceModel', res[2].data.deviceTypes)
            // console.log('deviceModel', state.deviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * 属性一覧とデバイス一覧を取得
   */
  loadSearchModel ({commit}, {serviceAttributeParams, deviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        [
          'serviceAttributeType',
          'device'
        ],
        [
          'v1ServiceAttributeTypeListGet',
          'v1DeviceListGet'
        ],
        [
          serviceAttributeParams,
          deviceParams
        ])
        .then(res => {
          console.log(res)
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setAttributeModel', res[0].data.serviceAttributeTypes)
            commit('setDeviceModel', res[1].data.deviceTypes)
            console.log('attributeModel', state.attributeModel)
            console.log('deviceModel', state.deviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * ロケーション一覧を読出し
   */
  loadVideoChatList ({commit}, {videoChatParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['videoChat'],
        ['v1VideoChatListGet'],
        [videoChatParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setVideoChatModel', res[0].data.phonebookLocations)
            console.log('videoChatModel', state.videoChatModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  resetState ({commit}) {
    commit('resetState')
  }
}

const mutations = {
  // model
  setServiceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  },
  setVideoChatModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'videoChatModel', data)
  },
  setDeviceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'deviceModel', data)
  },
  setAttributeModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'attributeModel', data)
  },
  setServiceInfoModel (state, data) {
    Vue.set(state, 'serviceInfoModel', data)
  },

  resetState (state) {
    Vue.set(state, 'serviceModel', [])
    Vue.set(state, 'videoChatModel', [])
    Vue.set(state, 'deviceModel', [])
    Vue.set(state, 'attributeModel', [])
    Vue.set(state, 'serviceInfoModel', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
